<agpr-dialog-container
    id="briefing.previewDialog"
    heading="Briefing.preview.dialog.heading"
    (close)="closeDialog()"
>
    <div class="agpr-sendPreviewDialog-content" [agprLoading]="loading">
        <agpr-message [severity]="messageSeverity.info">
            {{ 'Briefing.preview.dialog.infoMessage' | localize}}
        </agpr-message>
        <div
            class="sendPreviewDialog-content-radioGroup"
            role="radiogroup"
            [attr.aria-label]="'Briefing.preview.dialog.previewOptions' | localize"
        >
            <div class="agpr-sendPreviewDialog-mode">
                <agpr-radio
                    id="briefing.previewDialog.viewMode"
                    label="Briefing.preview.dialog.mode.view"
                    name="send_mode"
                    hiddenLabel="Briefing.preview.dialog.mode.view"
                    [value]="modes.view"
                    [(ngModel)]="mode"
                ></agpr-radio>
            </div>
            <div class="agpr-sendPreviewDialog-mode">
                <agpr-radio
                    id="briefing.previewDialog.sendMode"
                    label="Briefing.preview.dialog.mode.send"
                    name="send_mode"
                    hiddenLabel="Briefing.preview.dialog.mode.send"
                    [value]="modes.send"
                    [(ngModel)]="mode"
                ></agpr-radio>
            </div>
        </div>
        <div
            *ngIf="mode === modes.send"
            class="agpr-sendPreviewDialog-sendForm"
            [class.agpr-sendPreviewDialog-sendForm--open]="mode === modes.send"
        >
            <p class="agpr-sendPreviewDialog-description">
                {{ 'Briefing.preview.dialog.send.description' | localize }}
            </p>
            <agpr-text-input-chips
                id="briefing.previewDialog.recipients"
                [placeholder]="'Briefings.input.recipients.placeholder' | localize"
                [(ngModel)]="recipients"
                [chipValidations]="validateEmails"
                [splitOnPattern]="splitOnPattern"
            >
            </agpr-text-input-chips>
            <agpr-form-message
                *ngIf="showRecepientListError && recipients.length === 0"
            >
                {{ 'Briefings.input.recipients.validation' | localize }}
            </agpr-form-message>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            id="briefing.preview.cancel"
            label="cancel"
            [disabled]="loading"
            [style]="buttonTypes.secondary"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="briefing.preview.confirm"
            [label]="mode === modes.send ? 'Briefing.preview.dialog.confirm.send' : 'Briefing.preview.dialog.confirm.view'"
            [style]="buttonTypes.primary"
            [disabled]="loading"
            (click)="confirm()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
